import { render, staticRenderFns } from "./RowFilm.vue?vue&type=template&id=b8bb46d0&scoped=true&"
import script from "./RowFilm.vue?vue&type=script&lang=js&"
export * from "./RowFilm.vue?vue&type=script&lang=js&"
import style0 from "./RowFilm.vue?vue&type=style&index=0&id=b8bb46d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8bb46d0",
  null
  
)

export default component.exports